import router from './router'
import store from './store'

import eventBus from './eventBus'

export default {
  router,
  store,
  eventBus
}
